import { Component, ViewEncapsulation } from "@angular/core";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { Subscription, Observable } from "rxjs";
import { Routes } from "./routes.const";
import { FirebaseService, AuthService, DateService } from "./core";

export let browserRefresh = false;
declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = "LineLeap Dashboard";

  constructor(
    private router: Router,
    private auth: AuthService,
    private firebase: FirebaseService
  ) {}

  ngOnInit() {
    this.router.navigate(["/"]);
    this.initAuthListener();
    this.auth.disableAllPrivileges();
  }

  async initAuthListener() {
    this.auth.isLoggedIn.subscribe(async isLoggedIn => {
      if (isLoggedIn) {
        this.firebase.init(this.auth.user.uid, this.auth.owner);
        this.auth.admin
          ? this.router.navigate(Routes.ADMIN)
          : this.router.navigate(Routes.VENUE);
      } else {
        this.router.navigate(Routes.LOGIN);
      }
    });
  }
}
